export const addEvent = (target, event, listener, options) => {
    target.addEventListener(event, listener, options);
    return () => {
        target.removeEventListener(event, listener, options);
    };
};
//# sourceMappingURL=addEvent.js.map